import { useEffect } from "react";
import { useAccountBalanceData, useAccountData } from "../../../Hooks";
import { useBalance } from "../../../Hooks/useBalance";

export const useStablesPageData = () => {
  const {
    state: accountBalanceData,
    handleGET: fetchAccountBalanceGET,
    loading: balanceLoading,
    balanceValue,
  } = useAccountBalanceData();
  const {
    state: accountData,
    handleGET: fetchAccountGET,
  } = useAccountData();
  const { getBalance, loading: balanceRefreshLoading } = useBalance();

  useEffect(() => {
    fetchAccountBalanceGET();
    fetchAccountGET();
    getBalance();
  }, []);

  const reload = () => {
    fetchAccountBalanceGET();
    fetchAccountGET();
    getBalance();
  };

  const isBalanceLoading = balanceLoading.GET || balanceRefreshLoading?.GET;

  return {
    accountBalanceData,
    accountData,
    /** Account balance in centavos (matches `/accounts/balance` and `formatCurrency`). */
    brlBalance: balanceValue,
    brlBalanceFormatted: accountBalanceData?.balance,
    loadingBalance: isBalanceLoading,
    reload,
  };
};
